import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { updateLastVisitedOrgId } from '../action/display-settings/update-last-visited-org-id';
import { userSelector } from '../reducers/current-user-selectors';
import { lastVisitedOrgIdSelector } from '../reducers/display-settings-selectors';

type InputProps = {
  orgId?: number;
};

const mapStateToProps = (state: any) => {
  const user = userSelector(state);
  return {
    user,
    lastVisitedOrgId: user.username ? lastVisitedOrgIdSelector(state, user.username) : null,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    updateLastVisitedOrgId: (lastVisitedOrgId: number | null, username: string) =>
      dispatch(updateLastVisitedOrgId(lastVisitedOrgId, username)),
  },
});

export const useUpdateLastVisitedOrg = ({ orgId }: InputProps) => {
  const { user, lastVisitedOrgId } = useSelector(mapStateToProps, shallowEqual);
  const { actions } = mapDispatchToProps(useDispatch());

  if (orgId && user.username && lastVisitedOrgId !== orgId) {
    actions.updateLastVisitedOrgId(orgId, user.username);
  }

  return {
    orgId,
    user,
    lastVisitedOrgId,
  };
};
